import type { FileUploadFetch } from '~/types/FileUploadFetch'
import type { PictureSize, PictureTarget } from '~/types/Picture'
import type { UserKind } from '~/types/UserKind'

export function provideS3Upload(fileUploadFetch: FileUploadFetch) {
  return ({
    slug,
    userKind,
    userId,
    token,
    pictureBinary,
    target,
    onUploadProgress,
  }: {
    slug: string
    userKind: UserKind
    userId: number
    token: string
    pictureBinary: string
    target: PictureTarget
    onUploadProgress?: (progressEvent: any) => void
  }): Promise<PictureSize<PictureTarget>[]> => {
    return fileUploadFetch.$post('/picture/', pictureBinary, {
      headers: {
        user: userId,
        slug,
        kind: userKind,
        target,
        authorization: token,
      },
      onUploadProgress,
    })
  }
}
